import type { Sujet } from '@artosera/shared';
import { useOutletContext } from 'react-router';
import type { CompteSession, GalerieSession, SessionUtilisateur } from '../../api/types.js';

export interface ContexteCoquille {
  readonly session: SessionUtilisateur;
  readonly compte: CompteSession;
  readonly galerie: GalerieSession;
  readonly galerieSlug: string;
  readonly sujet: Sujet;
}

/** Contexte posé par `RegieShell` sur son `<Outlet>` : lu par chaque page de module. */
export function useShellContext(): ContexteCoquille {
  return useOutletContext<ContexteCoquille>();
}
